export default __webpack_public_path__ + "static/media/Sarah.a25adbe6.jpg";